import { render } from "./TheBearChaptersApp.vue?vue&type=template&id=41aa93fe&scoped=true"
import script from "./TheBearChaptersApp.vue?vue&type=script&lang=js"
export * from "./TheBearChaptersApp.vue?vue&type=script&lang=js"

import "./TheBearChaptersApp.vue?vue&type=style&index=0&id=41aa93fe&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aa93fe"]])

export default __exports__